import { useContractedProductsContext } from 'contexts/ContractedProductsProvider';

export const useContractedProducts = () => {
  const { contractedProducts } = useContractedProductsContext();
  return { contractedProducts };
};
